import {
    EditListPopup,
    PopupComponent,
    PopupElements
} from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { initPersonAddress } from './main';
import SearchFilter from './search-filter';
import { SortingList } from './sorting-list';

export default class PersonAddress {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: document.querySelector('[data-action="AddAddress"]'),
            editButtons: Array.from(
                document.querySelectorAll('[data-action="EditAddress"]')
            ),
            deleteButtons: Array.from(
                document.querySelectorAll('[data-action="RemoveAddress"]')
            )
        };

        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerAddressForm',
            removeItemUrl: 'CustomerCenter/DeletePersonAddress',
            addItemUrlParameters: [
                {
                    fieldName: 'personId',
                    dataAttributeTargetValue: 'data-person-id'
                }
            ],
            editItemUrlParameters: [
                {
                    fieldName: 'addressId',
                    dataAttributeTargetValue: 'data-address-id'
                }
            ],
            removeItemUrlParameters: [
                {
                    fieldName: 'addressId',
                    dataAttributeTargetValue: 'data-address-id'
                }
            ]
        };

        new EditListPopup().init(
            'AddressForm',
            'address-form-popup',
            popupElements,
            popupComponent,
            () => this.reloadComponent(),
            () => this.reloadComponent()
        );

        const component = document.querySelector(
            '[data-component=CustomerPersonAddresses]'
        );
        const personId = popupElements.addItemButton.getAttribute(
            'data-person-id'
        );

        const queryParams = { key: 'personId', value: personId };

        const filter = new SearchFilter(component, initPersonAddress, [
            queryParams
        ]);
        new SortingList(component, initPersonAddress, [queryParams], filter);
    }

    private reloadComponent(): void {
        const action = new ActionCreator().reloadComponent(
            'CustomerPersonAddresses'
        );
        action.successAction = () => initPersonAddress();

        new AjaxDispatcher().dispatchGetAction(action);
    }
}
